// extracted by mini-css-extract-plugin
export default {"wrap":"wrap---pMquq","centered":"centered---noFcT"};